import React from 'react'
import { useEffect, useRef, useState } from 'react';

const defaultEvents = [
  { time: '', title: 'Check-in', text: 'Team registration and welcome.' },
  { time: '', title: 'Opening ceremony', text: 'Greetings from the professors and Reply.' },
  { time: '', title: 'Case study presentation', text: 'Reply unveils the AI on Campus challenge.' },
  { time: '', title: "The hackathon begins", text: "Pick your idea and start building with the mentors." },
  { time: '', title: 'Lunch', text: 'A break before getting back to work.' },
  { time: '', title: 'End of work', text: 'Final tweaks and pitch preparation.' },
];

const Timeline = ({ events = defaultEvents }) => {
  const listRef = useRef(null);
  const [fill, setFill] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = listRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const px = window.innerHeight * 0.6 - r.top;
      setFill(Math.max(0, Math.min(r.height, px)));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <ul ref={listRef} className="relative max-w-[900px] pl-8 pt-8 mt-12 sm:pt-12 sm:mt-20">
      <span className="absolute bottom-0 left-[5px] top-0 w-0.5 bg-brand-white/50" />
      <span
        className="absolute left-[5px] top-0 w-0.5 bg-brand-blue"
        style={{ height: fill }}
      />

      {events.map((e, i) => {
        const [active, setActive] = [
          listRef.current && listRef.current.children[i + 2]
            ? listRef.current.children[i + 2].offsetTop + 8 <= fill
            : false,
        ];
        return (
          <li key={i} className="relative grid grid-cols-[1fr_1fr] sm:gap-4 pb-10">
            <span
              className={`absolute -left-8 top-2 h-3 w-3 rounded-full border-2 border-brand-blue transition-colors duration-300 ${
                active ? 'bg-brand-blue' : 'bg-black'
              }`}
            />
            {
              /*
              <time className="font-mono text-[15px] font-semibold text-brand-blue hidden">
                {e.time}
              </time>
             */
            }
            
            <div>
              <h3 className="font-display text-2xl font-black uppercase leading-tight text-brand-white">
                {e.title}
              </h3>
              <p className="font-display text-brand-white/50">{e.text}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default Timeline